import { render, staticRenderFns } from "./RubroSelection.vue?vue&type=template&id=a0ee8d3e&"
import script from "./RubroSelection.vue?vue&type=script&lang=js&"
export * from "./RubroSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports